import { render, staticRenderFns } from "./myMaterial.vue?vue&type=template&id=e000ec8c&scoped=true&lang=pug"
import script from "./myMaterial.vue?vue&type=script&lang=ts"
export * from "./myMaterial.vue?vue&type=script&lang=ts"
import style0 from "./myMaterial.vue?vue&type=style&index=0&id=e000ec8c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e000ec8c",
  null
  
)

export default component.exports